// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1hMSJ","modalForm":"UpgradeEpcsModal_modalForm__1D6VN","modalFooter":"UpgradeEpcsModal_modalFooter__1AsSJ"};